module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/medium.f84be9ea878fd790ea87.jpg";